<template>
  <el-row
    class="ads home__section"
    :gutter="20"
  >
    <el-col
      :xs="{ span: 24, offset: 0 }"
      :sm="{ span: 24, offset: 0 }"
      :md="{ span: 24, offset: 0 }"
      :lg="{ span: 24, offset: 0 }"
      :xl="{ span: 24, offset: 0 }"
    >
    <h2 class="ads__title"></h2>
    <div class="ads__image">
      <a :href="ads_Url"  target="_blank">
        <img :src="ads_ImageSrc">
      </a>
    </div>
    </el-col>
  </el-row>
    
</template>

<script>
  import axios from "axios"
//import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'app',
  data () {
    return {
      src: 'https://teachersdownload.s3.ap-northeast-1.amazonaws.com/',
      //images: ['christmas2.jpg','doris_story.jpg'],
      images: [],
      link: [],
      image_fn: [],
      ads_ImageSrc: null,
      ads_Url: null
    }
  },

  mounted() {
    //console.log('From getAds')
    axios.get("getAds.php")
    .then((response)=> {
      //console.log(response.data.data);
      this.imgs = response.data.data;
      let self = this
      //console.log(this.imgs.length)
      var arr = [];
      let obj = this.imgs
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            var innerObj = {};
            innerObj[prop] = obj[prop];
            arr.push(innerObj)
          }
        }
    
        //console.log(arr);
	//console.log('DDD');
	
        
      
    setInterval(function(){ 
        var now_id = Math.floor(Math.random()*arr.length); 
        //console.log('ID '+now_id);
	//console.log(arr[now_id][now_id]['fileName'])
	//console.log(`${this.src}${arr[now_id][now_id]['fileName']}`)
	self.ads_ImageSrc = 'https://teachersdownload.s3.ap-northeast-1.amazonaws.com/'+arr[now_id][now_id]['fileName'];
	//console.log(self.ads_ImageSrc);
	self.ads_Url = arr[now_id][now_id]['url'];
	//console.log(self.ads_Url);
    }, 5000);
      

    })
    .catch(function (error) {
      console.log(error);
    })
    
    
  },
  
  computed: {
    
   
    
  },

  methods: {
    
  },
  created () {
    //console.log('A-url')
    
  }
}
</script>
